
import { Component, Mixins } from "vue-property-decorator";
import { ISize } from "../../../../../../../base/domain/drawing";
import { DomainRegistry } from "../../../../../../domain";
import { instanceOfIImageContentPropertyEditable, instanceOfISizePropertyEditable } from "../../../../../../domain/editableFormat/properties";
import { QuoteBehaviorPropertyEditableMixin, ImageContentPropertyEditableMixin } from "../../../mixins";
import { default as RectangleCoordinatableObjectDrawerBase } from "./RectangleCoordinatableObjectDrawerBase.vue";

@Component
export default class ImageDrawableObjectDrawerBase extends Mixins(RectangleCoordinatableObjectDrawerBase, QuoteBehaviorPropertyEditableMixin, ImageContentPropertyEditableMixin) {
  get isEnableImageSource(): boolean {
    return this.imageContent.isEnable || this.temporaryImageContent.isEnable;
  }

  get imageStyle(): any {
    return this.isEnableImageSource
      ? {
        backgroundImage: "url(" + this.imageSource + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }
      : null;
  }

  get imageSource(): string {
    if (!this.isEnableImageSource) {
      return null;
    }
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = this.temporaryImageContent.isEnable
      ? repository.getTemporaryImageSource(this.temporaryImageContent.guid)
      : repository.getImageSource(this.formatId, this.imageContent.guid);
    return imageSource.source;
  }

  addTemporaryImage(imageGuid: string, size: ISize<number>) {
    this.getCommonComponents().getStoreEditor().setTemporaryImages(this.storePresenter.getTemporaryImages().concat([{
      imageGuid: imageGuid,
      size: size,
    }]));
  }

  setImageContentProperty(imageGuid: string, size: ISize<number> = null) {
    this.writePropertyWhenValid(s => {
      if (instanceOfIImageContentPropertyEditable(s)) {
        s.temporaryImageContent().setValue({ guid: imageGuid, isEnable: true });
      }
      if (!!size && instanceOfISizePropertyEditable(s)) {
        s.size().setValue(size);
      }
    });
  }
}
